// extracted by mini-css-extract-plugin
export var heading = "v3-structured-text-content-module--heading--c32b8";
export var structuredText = "v3-structured-text-content-module--structuredText--54784";
export var textBlock = "v3-structured-text-content-module--textBlock--46e6c";